module.exports = __webpack_public_path__ + "static/arrow.up.dots.purple-d76173d118ae50d9f5ce38a0e6beecc2.png";